import BackendModel from 'ln/model/BackendModel';

class ExtensionModel extends BackendModel {

	constructor( json: Object ){
		super( json );
	}

	/**
	* Overwrites the get function to look up also in origin model
	*/
	get<T>( key:string, fallback:T = undefined ):T {
		var value = super.get( key, fallback );
		if( key == 'id' || key == 'modelName' ) return value; // the id or modelname should not be resolved on origin.
		return ( value == undefined ) ? this.getOriginProperty<T>( key ) : value;
	}

	getOriginProperty<T>( key:string ):T {
		var org = this._obj[ "origin" ];
		if( !org ) return undefined;
		if( key === 'time' ){
			return ( org instanceof BackendModel ) ? org.get<number>( key, 0 ) as any : org[ key ] == '' ? 0 : org[key];
		} 
		return ( org instanceof BackendModel ) ? org.get<T>( key ) : org[ key ];
	}
}

export default ExtensionModel;